module.exports = __webpack_public_path__ + "static/media/cellphone.d1c612e7.png";